import { Deserializable } from '../_common/deserializable';

export class ContentEpisode implements Deserializable {
      id: number;
      contentId: number;
      title: string;
      content: string;
      description: string;
      createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
